module.exports = __webpack_public_path__ + "static/ASCOVIME - Patient Consultation 2_2019-c24793424181d6860edad70c336c6391.jpg";